"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ThreeDimensionalSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var ThreeDimensionalSVG = function ThreeDimensionalSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M3 9.5v11.7a2 2 0 00.9 1.7L15 30.2V16.4zM28 7.8L17 1.4a2.3 2.3 0 00-2 0L4 7.8l12 6.9zM17 16.4v13.8l11.1-7.3a2 2 0 00.9-1.7V9.5z"
  }));
};
exports.ThreeDimensionalSVG = ThreeDimensionalSVG;
ThreeDimensionalSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(ThreeDimensionalSVG);
exports.default = _default;